// 站內導航守衛的登記處。react-router 同一時間只認一個 useBlocker（多個會互相吃掉），
// 所以全站只有 AppLayout 呼叫 useBlocker，頁面要「未儲存離開確認」這類守衛時改用 useLeaveGuard 登記。
// （eslint 已禁止在 AppLayout 以外 import useBlocker）
//
// 用法（頁面內）：
//   useLeaveGuard({
//     shouldBlock: ({ nextLocation, historyAction }) => dirty,  // 回傳 true 就擋下這次導航
//     onBlocked: (blocker) => openConfirm({                     // 擋下後要做什麼；之後必須呼叫其一：
//       onOk: () => blocker.proceed(),                          //   放行
//       onCancel: () => blocker.reset(),                        //   取消，留在原頁
//     }),
//   })
import { useEffect, useRef } from 'react'

const guards = new Set()

export function useLeaveGuard(guard) {
  const ref = useRef(guard)
  useEffect(() => {
    ref.current = guard
  })
  useEffect(() => {
    guards.add(ref)
    return () => guards.delete(ref)
  }, [])
}

// 給 AppLayout 用：回傳第一個要求擋下的守衛，沒有就回傳 null
export function findBlockingGuard(args) {
  for (const ref of guards) {
    if (ref.current.shouldBlock(args)) return ref.current
  }
  return null
}
